import { connect } from "react-redux";
import { Selectors } from "@/store/saloonProfile/selectors";
import { Selectors as AuthSelectors } from "@/store/auth/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Selectors as FavSelectors } from "@/store/favorites/selectors";
import { Selectors as PortfolioSelectors } from "@/store/portfolio/selectors";
import { Effects as PortfolioEffects } from "@/store/portfolio/effects";
import { Actions as PortfolioActions } from "@/store/portfolio/slice";
import { Actions as ModalActions } from "@/store/modals/slice";

import Slider from "_c/modules/profile/common/PortfolioSlider";

const mSp = (state) => ({
  isOwner: Selectors.isOwner(state),
  isAuth: AuthSelectors.isAuth(state),
  authUserId: UserSelectors.getUserId(state),
  items: PortfolioSelectors.getPortfolio(state),
  favorites: FavSelectors.getFavoritePortfolio(state),
  loading: Selectors.isLoading(state),
  uploaderId: Selectors.getId(state),
  isGalleryOpen: PortfolioSelectors.isGalleryOpen(state),
  galleryIdx: PortfolioSelectors.getGalleryIdx(state),
  defaultSlideAltText: Selectors.getPortfolioDefaultAltText(state),
});
const mDp = {
  toggleLike: PortfolioEffects.toggleLike,
  addPortfolio: PortfolioEffects.addPortfolio,
  removePortfolio: PortfolioEffects.removePortfolio,
  addComment: PortfolioEffects.addComment,
  removeComment: PortfolioEffects.removeComment,
  openGallery: PortfolioActions.openGallery,
  closeGallery: PortfolioActions.closeGallery,
  openShareModal: ModalActions.openShare,
};

export default connect(mSp, mDp)(Slider);
